import { Image, Appear } from 'mdx-deck';
import { CodeSurfer, CodeSurferColumns, Step } from 'code-surfer';
import { vsDark } from '@code-surfer/themes';
import Me from "../../../../../../Me";
import References from "../../../../../../References";
import Multiline from "../../../../../../Multiline";
import Logos from "../../../../../../Logos";
import typescript from "../../../../../../images/typescript.png";
import React from 'react';
export default {
  Image: Image,
  Appear: Appear,
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  vsDark: vsDark,
  Me: Me,
  References: References,
  Multiline: Multiline,
  Logos: Logos,
  typescript: typescript,
  React: React
};